enum PromotionalPackageDefaultCopy {
    TITLE = 'Progetto Valore Volkswagen',
    CUSTOM_INSTALLMENT = 'Scegli il modello perfetto per te con <strong>rata personalizzata</strong>',
    EXTENDED_WARRANTY = "Inclusa nel prezzo hai <strong>l'estensione di garanzia</strong> Extra Time 2 anni o fino a 80.000 Km",
    REPLACEMENT = '<strong>Dopo 3 anni sei libero di restituirla, sostituirla</strong> con una nuova Volkswagen, continuando a beneficiare dei vantaggi di "Progetto Valore Volkswagen" <strong>oppure tenerla</strong> con la sicurezza del Valore Futuro Garantito pari alla rata finale',
}

export default PromotionalPackageDefaultCopy
